import { render, staticRenderFns } from "./fateSpec.vue?vue&type=template&id=26b763da&scoped=true&"
import script from "./fateSpec.vue?vue&type=script&lang=ts&"
export * from "./fateSpec.vue?vue&type=script&lang=ts&"
import style0 from "./fateSpec.vue?vue&type=style&index=0&id=26b763da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b763da",
  null
  
)

export default component.exports